import React, { Component } from "react";

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li>
                        <img src="/assets/images/melomate/brand/brand-01.png" alt="Melo Project"/>
                    </li>
                    <li>
                        <img src="/assets/images/melomate/brand/brand-02.png" alt="Melo Project"/>
                    </li>
                    <li>
                        <img src="/assets/images/melomate/brand/brand-03.png" alt="Melo Project"/>
                    </li>
                    <li>
                        <img src="/assets/images/melomate/brand/brand-04.png" alt="Melo Project"/>
                    </li>
                    <li>
                        <img src="/assets/images/melomate/brand/brand-05.png" alt="Melo Project"/>
                    </li>
                    <li>
                        <img src="/assets/images/melomate/brand/brand-06.png" alt="Melo Project"/>
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;